/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneGhost/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneGhost({
  children,
  viewPath = "/DesignSystem/TysiaSelectOneGhost",
  alignSelf = "flex-start",
  parentRef,
  alignItems,
  flexDirection = "column",
  flexGrow = 0,
  flexShrink = 1,
  flexBasis,
  marginTop = 0,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  width = "100%",
  height,
  maxWidth,
  onMouseEnter,
  onMouseLeave,
  from,
  required,
  optionsWidth,
  optionValue,
  size,
  focused,
  disabled,
  hovered,
  invalid,
  valid,
  selectedPlaceholder,
  clearFilterOnBlur,
  placeholder = "Select...",
  value,
  isSelected,
  isMultiChoice,
  allowEmptyChoice = true,
  onClick,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  onChangeFilter,
  valueFilter,
  onKeyUp,
  isShowingOptions,
  optionsRef,
  inputRef,
  fromCustom,
  onClickAddFilterAsCustomOption,
  isShowingAddFilterAsCustomOption,
  selected,
  isSelectedAll,
  isEmpty,
  onClickToggleAll,
  showSelectAll
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneGhost.Vertical"
  data-view-path={viewPath}
 innerRef={parentRef}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--as-1-Z1N2NKK': alignSelf,'--ai-2-Z1N2NKK': alignItems,'--fd-3-Z1N2NKK': flexDirection,'--fg-4-Z1N2NKK': flexGrow,'--fs-5-Z1N2NKK': flexShrink,'--fb-6-Z1N2NKK': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--mt-7-Z1N2NKK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-8-Z1N2NKK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-9-Z1N2NKK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-10-Z1N2NKK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--w-11-Z1N2NKK': typeof width === 'number' ? `${width}px` : width,'--h-12-Z1N2NKK': typeof height === 'number' ? `${height}px` : height,'--mw-13-Z1N2NKK': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 from={from}
 required={required}
 optionsWidth={optionsWidth}
 optionValue={optionValue}
 size={size}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 selectedPlaceholder={selectedPlaceholder}
 clearFilterOnBlur={clearFilterOnBlur}
 placeholder={placeholder}
 value={value}
 isSelected={isSelected}
 isMultiChoice={isMultiChoice}
 allowEmptyChoice={allowEmptyChoice}
 onClick={onClick}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 onChangeFilter={onChangeFilter}
 valueFilter={valueFilter}
 onKeyUp={onKeyUp}
 isShowingOptions={isShowingOptions}
 innerRef={optionsRef}
 inputRef={inputRef}
 fromCustom={fromCustom}
 onClickAddFilterAsCustomOption={onClickAddFilterAsCustomOption}
 isShowingAddFilterAsCustomOption={isShowingAddFilterAsCustomOption}
 selected={selected}
 isSelectedAll={isSelectedAll}
 isEmpty={isEmpty}
 onClickToggleAll={onClickToggleAll}
 showSelectAll={showSelectAll}
>
{children}
</Children>
</div>
</React.Fragment>)
}